import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pad10 with_white_bg noscroll",
  style: {"height":"420px","width":"380px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs24 kakugo centered fw600",
  style: {"color":"#696969"}
}, "外部カレンダー連携", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt20" }, " カレンダー連携をしておくことで、 日時を都度入力せず、お相手に空いている時間のみを 自動的に提案できます。 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "w100 centered" }
const _hoisted_9 = {
  href: "/sign_in/google",
  class: "AuthButton mb"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  href: "/sign_in/ms",
  class: "AuthButton mt40"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_18 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 grey fw600" }, "今後表示しない", -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ConnectCalendarModal",
    "content-class": "modalContent shadowContent rad10 noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass(`title ${_ctx.isSP ? `mt20` : `mt40`}`)
        }, _hoisted_4, 2),
        _hoisted_5,
        _createElementVNode("div", null, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("a", _hoisted_9, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/buttons/google_bnr.png`),
                  width: "260",
                  height: "58"
                }, null, 8, _hoisted_10)
              ]),
              _hoisted_11
            ]),
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", null, [
              _createElementVNode("a", _hoisted_14, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/buttons/microsoft_bnr.png`),
                  width: "260",
                  height: "58"
                }, null, 8, _hoisted_15)
              ]),
              _hoisted_16
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("section", {
            class: "w100 lgreyBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAndNoDisp && _ctx.closeAndNoDisp(...args)))
          }, _hoisted_20)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}